'use strict';



export default class login {
	constructor() {
		$('.login-holder input:text, .pay-holder input:text').bind('keyup', function(e){
			if(e.keyCode == 32){
				e.target.value = e.target.value.replace(e.key, '');
			}
			$(this).val($(this).val().toUpperCase());
			
		});
        $('.login-holder input:text, .pay-holder input:text').on({
            paste: function(e) {
				    var stopPaste = function(){
                    this.value = this.value.replace(/[|\s]/g, '');
					this.value = this.value.toUpperCase();
                };
                setTimeout(stopPaste.bind(this), 1);
            }
        });

		$('#LoginStep1Form').on("submit", function (event) {		
			var data = {
				Identifier: $('input[name="Identifier"]').val()
			};
			
			$.ajax({
			  type: "GET",
			  url: "/api/sitecore/Login/ValidateObligation",
			  data: data,
			  beforeSend: Step1Loading,
			  success: ShowStep2,
			  error: Step1Error
			}).done(function (resultdata) {
			  console.log(resultdata);
			});

			event.preventDefault();
		  });
		
		function Step1Loading(){
			$('#LoginStep1Form input').attr('disabled','disabled').addClass('disabled');
			$('#LoginStep1Form .cssload-container').show();
		}

		function ShowStep2(responseText, statusText, xhr, $form) {
			$('#LoginStep1Form label.error-message').text('');
			$('#LoginStep1Form input').removeAttr('disabled').removeClass('disabled');

			$('#LoginStep1Form').hide();
			$('#LoginStep1Form .cssload-container').hide();

			var json = $.parseJSON(xhr.responseText);

			if(json.RequiresOffenceDate)
			{
				$('#LoginStep2Form input[name="OffenceDate"]').closest('.DOB').find('input.day-selector').attr('required','');
				$('#LoginStep2Form input[name="OffenceDate"]').closest('.DOB').find('input.month-selector').attr('required','');
				$('#LoginStep2Form input[name="OffenceDate"]').closest('.DOB').find('input.year-selector').attr('required','');
				$('#LoginStep2Form input[name="OffenceDate"]').closest('.DOB').show();
				$('#LoginStep2Form label[for="OffenceDate"]').show();
			}

			if(json.RequiresHearingDate)
			{
				$('#LoginStep2Form input[name="HearingDate"]').closest('.DOB').find('input.day-selector').attr('required','');
				$('#LoginStep2Form input[name="HearingDate"]').closest('.DOB').find('input.month-selector').attr('required','');
				$('#LoginStep2Form input[name="HearingDate"]').closest('.DOB').find('input.year-selector').attr('required','');
				$('#LoginStep2Form input[name="HearingDate"]').closest('.DOB').show();
				$('#LoginStep2Form label[for="HearingDate"]').show();
			}

			if(json.RequiresDriversLiscence)
			{
				$('#LoginStep2Form input[name="DriversLicenceNumber"]').attr('required','').show();
				$('#LoginStep2Form label[for="DriversLicenceNumber"]').show();
			}
			
			if(json.RequiresVehicleRegistraton)
			{
				$('#LoginStep2Form input[name="VehicleRegistratonNumber"]').attr('required','').show();
				$('#LoginStep2Form label[for="VehicleRegistratonNumber"]').show();
			}

			if(json.RequiresDateOfBirth)
			{
				$('#LoginStep2Form input[name="DateOfBirth"]').closest('.DOB').find('input.day-selector').attr('required','');
				$('#LoginStep2Form input[name="DateOfBirth"]').closest('.DOB').find('input.month-selector').attr('required','');
				$('#LoginStep2Form input[name="DateOfBirth"]').closest('.DOB').find('input.year-selector').attr('required','');
				$('#LoginStep2Form input[name="DateOfBirth"]').closest('.DOB').show();
				$('#LoginStep2Form label[for="DateOfBirth"]').show();
			}
			
			$('#LoginStep2Form input[name="Identifier"]').val(json.Identifier);
			$('#LoginStep2Form').show();
		}

		function Step1Error (xhr, ajaxOptions, thrownError) {
			$('#LoginStep1Form input').removeAttr('disabled').removeClass('disabled');
			$('#LoginStep1Form .cssload-container').hide();

			var json = {};
			try
			{
				json = $.parseJSON(xhr.responseText);
			}
			catch(err){
				//was not passed back valid Json, we will just display a generic error message in this case.
			}

			$('#LoginStep1Form .error-message.non-ng').css("display", "block");
			$('#LoginStep1Form .error-message p').html(json.Error || "Something went wrong while processing the request.");
	    }
		
		$('#LoginStep2Form').on("submit", function (event) {		
			$.ajax({
			  type: "POST",
			  url: "/api/sitecore/Login/ValidateDebtor",
			  data: { 
				Identifier: $('#Identifier').val(), 
				OffenceDate: $('#OffenceDate').val(),
				HearingDate: $('#HearingDate').val(),
				DriversLicenceNumber: $('#DriversLicenceNumber').val(),
				VehicleRegistratonNumber: $('#VehicleRegistratonNumber').val(),
				DateOfBirth: $('#DateOfBirth').val()
			  },
			  beforeSend: Step2Loading,
			  success: Setp2Success,
			  error: Step2Error
			}).done(function (resultdata) {
			  console.log(resultdata);
			});

			event.preventDefault();
	    });
		  
		function Step2Loading(){
			$('#LoginStep2Form input, #LoginStep2Form select').attr('disabled','disabled').addClass('disabled');
			$('#LoginStep2Form .cssload-container').show();
		}

		function Setp2Success(responseText, statusText, xhr, $form) {

			$('#LoginStep2Form input, #LoginStep2Form select').removeAttr('disabled').removeClass('disabled');
			$('#LoginStep2Form .cssload-container').hide();

			if(responseText.Result == true)
			{
				window.location = responseText.RedirectUrl;
			}
			else
			{
				$('#LoginStep2Form .error-message.non-ng').css("display", "block");
				$('#LoginStep2Form .error-message p').text("Sorry, we are unable to verify the details you have provided. Please check the details and try again.");
			}
		}
	    function Step2Error (xhr, ajaxOptions, thrownError) {


			$('#LoginStep2Form input, #LoginStep2Form select').removeAttr('disabled').removeClass('disabled');
			$('#LoginStep2Form .cssload-container').hide();

			var json = {};
			try
			{
				json = $.parseJSON(xhr.responseText);
			}
			catch(err){
				//was not passed back valid Json, we will just display a generic error message in this case.
			}
			$('#LoginStep2Form .error-message.non-ng').css("display", "block");
			$('#LoginStep2Form .error-message p').html(json.Error || "Something went wrong while processing the request.");
	    }
		$( "#LoginStep1Form input" ).change(function() {
  			$('#LoginStep1Form .error-message.non-ng').css("display", "none");
		});
		$( "#LoginStep2Form input" ).change(function() {
  			$('#LoginStep2Form .error-message.non-ng').css("display", "none");
		});
	}
}
//<div class="cssload-container"><div class="cssload-whirlpool"></div></div>